import { render, staticRenderFns } from "./navtags.vue?vue&type=template&id=b2a9a98a&"
import script from "./navtags.vue?vue&type=script&lang=js&"
export * from "./navtags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports